import { memo, useCallback, useId } from 'react';
import styles from '../styles/HtsCheckbox.module.scss';
import { HtslIcon } from './HtsIcon';

interface HtsCheckboxProps {
  checked: boolean;
  disabled?: boolean;
  containerClassName?: string;
  onChecked?: (checked: boolean) => void;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const HtsCheckbox: React.FC<HtsCheckboxProps> = memo(
  ({ checked, disabled, containerClassName = '', onChecked, onChange }) => {
    const checkboxId = useId();

    const handleChange = useCallback(
      (e: React.ChangeEvent<HTMLInputElement>) => {
        const checked = e.target.checked;

        onChecked?.(checked);
        onChange?.(e);
      },
      [onChecked, onChange]
    );

    const onClick = useCallback((e: React.MouseEvent<HTMLInputElement>) => {
      e.stopPropagation();
    }, []);

    return (
      <div
        id={checkboxId}
        className={`${styles.container} ${containerClassName}`}
        style={{
          pointerEvents: disabled ? 'none' : 'auto',
          opacity: disabled ? 0.5 : 1,
          cursor: disabled ? 'not-allowed' : 'pointer',
        }}
      >
        <input
          type="checkbox"
          id={checkboxId}
          className={styles.input}
          checked={checked}
          onChange={handleChange}
          onClick={onClick}
        />

        <label className={styles.label}>
          <HtslIcon icon="check-mark" className={styles.icon} />
        </label>
      </div>
    );
  }
);
